<template>
  <span>
    Connect your organization to Apple's Volume Purchase Program (VPP) to manage your organizations
    access to App Store apps. An account with
    <a
      href="https://business.apple.com/"
      rel="noopener noreferrer"
      target="_blank"
    >
      Apple Business Manager
    </a> or
    <a
      href="https://school.apple.com/"
      rel="noopener noreferrer"
      target="_blank"
    >
      Apple School Manager
    </a>
    is required.
  </span>
</template>

<script>
export default {
  name: 'InstructionTextMdmVpp',
};
</script>
